import React from "react";
import { CssBaseline, Box } from "@mui/material";

import "../components/home/home.style.css";
import Newsidebar from "../components/shared/newsidebar";
import MetaDecorator from "../services/meta_decorator";
import Newheader from "../components/shared/newheader";
import MyPupil from "../components/home/mypupil";
import InactivityMeter from "../components/shared/inactivitymeter";
import Footer from "../components/shared/footer";
import { bodyBg2 } from "../style2";

export default function PatientList() {
  return (
    <Box sx={bodyBg2}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Professional Dashboard"} description={"Professional dashboard app"} />
      <Box>
        <Newheader show_back_button={false} show_profile_button={true} />
        <Newsidebar />
        <Box sx={{ minHeight: "calc(100vh - 90px)", paddingBottom: '50px' }}>
          <MyPupil />
          <InactivityMeter />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
}
